import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import InfoLabel from '../InfoLabel/InfoLabel';
const UserLabel = ({
  userType,
  userName
}) => {
  let value = '';
  if (userType !== 'customer') {
    value = userName;
  }

    return (
      <InfoLabel
        label="User"
        value={value}
        labelSize={4}
      />
    );
};

UserLabel.propTypes = {
  userName: PropTypes.string,
  userType: PropTypes.string,
};

export default UserLabel;
